import * as React from "react";
import { ModelUser } from "@dia-ui/util_interlink-api";
import { useContext } from "react";
import { AppContext } from "../../context/AppContext";

interface CompanyUserFormProps {

  user: ModelUser | null;

}

/**
 * read-only view of a company user. the fields used to render as editable
 * inputs without any save path; now they say what they are
 */
const CompanyUserForm: React.FC<CompanyUserFormProps> = ({ user }) => {
  const { I18N } = useContext(AppContext);

  /**
   * salutationName
   */
  const salutationName = (salutation: string): string => {
    switch (salutation) {
      case "male": return I18N.t("Herr");
      case "female": return I18N.t("Frau");
      case "divers": return I18N.t("Divers");
      default: return salutation || "";
    }
  };

  return (
    <dia-form>
      <form action="#" method="POST">
        <dia-form-area>
          <dia-form-line>
            <dia-form-control>
              <input id="company-user-salutation" type="text" name="salutation" placeholder="" value={ salutationName(user?.salutation || "") } readOnly />
              <label htmlFor="company-user-salutation">{I18N.t("Anrede")}</label>
            </dia-form-control>
            <dia-form-control>
              <input id="company-user-title" type="text" name="title" placeholder="" value={user?.title || ""} readOnly />
              <label htmlFor="company-user-title">{I18N.t("Titel")}</label>
            </dia-form-control>
          </dia-form-line>
          <dia-form-line>
            <dia-form-control>
              <input id="company-user-firstname" type="text" name="firstname" placeholder="" value={user?.firstname || ""} readOnly />
              <label htmlFor="company-user-firstname">{I18N.t("Vorname")}</label>
            </dia-form-control>
            <dia-form-control>
              <input id="company-user-lastname" type="text" name="lastname" placeholder="" value={user?.lastname || ""} readOnly />
              <label htmlFor="company-user-lastname">{I18N.t("Nachname")}</label>
            </dia-form-control>
          </dia-form-line>
          <dia-form-line>
            <dia-form-control>
              <input id="company-user-position" type="text" name="position" placeholder="" value={user?.position || ""} readOnly />
              <label htmlFor="company-user-position">{I18N.t("Position")}</label>
            </dia-form-control>
            <dia-form-control>
              <input id="company-user-department" type="text" name="department" placeholder="" value={user?.department || ""} readOnly />
              <label htmlFor="company-user-department">{I18N.t("Abteilung")}</label>
            </dia-form-control>
          </dia-form-line>
          <dia-form-line>
            <dia-form-control>
              <input id="company-user-email" type="email" name="email" placeholder="" value={user?.email || ""} readOnly />
              <label htmlFor="company-user-email">{I18N.t("E-Mail-Adresse")}</label>
            </dia-form-control>
            <dia-form-control>
              <input id="company-user-fon" type="tel" name="fon" placeholder="" value={user?.fon || ""} readOnly />
              <label htmlFor="company-user-fon">{I18N.t("Telefon")}</label>
            </dia-form-control>
            <dia-form-control>
              <input id="company-user-mobil" type="tel" name="mobil" placeholder="" value={user?.mobil || ""} readOnly />
              <label htmlFor="company-user-mobil">{I18N.t("Mobil")}</label>
            </dia-form-control>
          </dia-form-line>
          <dia-form-line>
            <dia-form-control>
              <input id="company-user-linkedin" type="url" name="linkedin" placeholder="" value={user?.linkedin || ""} readOnly />
              <label htmlFor="company-user-linkedin">{I18N.t("Linked-In")}</label>
            </dia-form-control>
          </dia-form-line>
        </dia-form-area>
      </form>
    </dia-form>
  );
};

export default CompanyUserForm;
